import { Component, type ReactNode } from "react";

export function reloadApplication() { window.location.reload(); }

/** Keep a failed lazy import/render visible; never reload and discard input automatically. */
export class AppRecoveryBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override render() {
    if (!this.state.failed) return this.props.children;
    return <main className="boot-screen">
      <section className="content-card service-error" role="alert">
        <h1>เปิดหน้าจอไม่สำเร็จ / ເປີດໜ້າຈໍບໍ່ສຳເລັດ</h1>
        <p>อาจมีการอัปเดตระบบหรือการเชื่อมต่อขัดข้อง กรุณาโหลดหน้าใหม่</p>
        <p>ອາດມີການອັບເດດລະບົບ ຫຼື ການເຊື່ອມຕໍ່ຂັດຂ້ອງ ກະລຸນາໂຫຼດໜ້າໃໝ່</p>
        <p>ข้อความที่ยังไม่บันทึกอาจหายไป / ຂໍ້ຄວາມທີ່ຍັງບໍ່ບັນທຶກອາດຫາຍໄປ</p>
        <button className="button button-primary" type="button" onClick={reloadApplication}>โหลดหน้าใหม่ / ໂຫຼດໜ້າໃໝ່</button>
      </section>
    </main>;
  }
}
